<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title">One Foot in the Grave</p>
<p class="ORIM-Book-Subtitle">A James Pibble Mystery</p>
<p class="ORIM-Author-Name">Peter Dickinson</p>
<p class="center"><img alt="logo" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dickinson_OneFootintheGrave_3P_MD.vue?584c17d0